<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-4">
          <div class="row align-items-center">
            <div class="col-9 font-size-16">Criar um novo usuário</div>
            <div class="col-3">
              <button type="button" class="btn btn-sm btn-info float-end" @click="newUser">Voltar</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form @submit.prevent="onSubmit">
            <div class="row align-items-center">
              <div class="col-3">
                <app-input-text v-model="user.name" label="*Nome" c_css @input="checkFormFilled" />
              </div>
              <div class="col-3">
                <app-input-text v-model="user.email" label="*E-mail" c_css @input="checkFormFilled" />
              </div>
              <div class="col-3" v-if="!selectedUser.name">
                <app-input-password v-model="user.pwd" label="*Senha" c_css @input="checkFormFilled" />
              </div>
              <div class="col-3">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" v-model="user.admin" />
                  <label class="form-check-label">Administrador</label>
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-12">
                <label class="form-check-label mb-2">Grupo(s)</label>
                <br />
                <button
                  v-for="(item, key) in squads"
                  v-bind:key="key"
                  type="button"
                  class="btn font-size-14 m-1"
                  @click="handleGroup(item.id)"
                  v-bind:class="[group.indexOf(item.id)>=0 ? 'btn-outline-success' : 'btn-outline-secondary']"
                >{{item.name}}</button>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <button
                  type="submit"
                  class="btn btn-primary waves-effect waves-light"
                  :disabled="!isFormFilled"
                >Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppInputText from "@/components/AppInputText/AppInputText.vue";
import AppInputPassword from "@/components/AppInputPassword/AppInputPassword.vue";
import { mapActions } from "vuex";
export default {
  props: {
    squads: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    AppInputText,
    AppInputPassword
  },
  data() {
    return {
      successMessage: "Criado com sucesso!",
      group: [],
      selectedUser: {},
      isFormFilled: false,
      user:{
        name: null,
        email: null,
        pwd: null,
        admin: false,
      }
    };
  },
  computed: {
    toggleActive() {
      return {
        active: this.isActive,
        "toggle-on": this.isActive,
        "toggle-off": !this.isActive
      };
    }
  },
  mounted() {
    if (Object.keys(this.selected).length > 0) {
      this.selectedUser = this.selected;
      this.user.name = this.selectedUser.name;
      this.user.email = this.selectedUser.email;
      this.user.pwd = '';
      this.user.admin = this.selectedUser.role == "admin" ? true : false;
      if (Object.keys(this.selectedUser.teams).length > 0) {
        this.group = this.selectedUser.teams.map(item => {
          return item.id;
        });
      }
    }
    this.checkFormFilled();
  },

  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    checkFormFilled() {
      if (Object.keys(this.selected).length > 0) {
        this.isFormFilled = this.user.name !== null && this.user.email !== null;
      }else{
        this.isFormFilled = this.user.name !== null && this.user.email !== null && this.user.pwd !== null;
      }
    },
    handleGroup(g) {
      let index = this.group.indexOf(g);
      index >= 0 ? this.group.splice(index, 1) : this.group.push(g);
    },
    newUser() {
      this.$emit("handle", "ddooos");
    },
    async onSubmit() {
      this.showLoader(true);
      let _this = this;
      const options = {};
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `Bearer ${
          JSON.parse(this.$ls.get(process.env.VUE_APP_LOCAL_STORAGE_NAME)).token
        }`
      };
      const data = {
        name: this.user.name,
        email: this.user.email,
        admin: this.user.admin === true ? "admin" : "user",
        group: []
      };

      if (this.group.length > 0) {
        for (let i = 0; i < this.group.length; i++) {
          let tempGroup = {};
          tempGroup.team_id = this.group[i];
          tempGroup.is_admin = 0;//this.user.admin;
          data.group.push(tempGroup);
        }
      }

      if (Object.keys(this.selected).length === 0) {
        data.password = this.user.pwd;
        data.c_password = this.user.pwd;
        options.method = "POST";
        options.url = `${process.env.VUE_APP_ROOT_API}user`;
        options.headers = headers;
        options.data = data;
      }
      else{
        options.method = "PATCH";
        options.url = `${process.env.VUE_APP_ROOT_API}user/${this.selected.id}`;
        options.headers = headers;
        options.data = data;
      }
      
      this.axios(options)
        .then(function(response) {
          _this.showLoader(false);
          _this.showMessage({
            title: _this.successMessage,
            css: "bg-success"
          });
          _this.newUser();
        })
        .catch(function(error) {
          _this.showLoader(false);
          console.log(error);
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    }
  }
};
</script>
<style scoped>
.btn-outline-secondary {
  border: 2px solid #d2d6da !important;
  font-size: 0.875rem !important;
  font-weight: 400 !important;
  color: #7b809a !important;
}
.btn-outline-secondary:hover,
.btn-outline-secondary:focus {
  border: 2px solid #d2d6da !important;
  background: #d2d6da !important;
  color: #000 !important;
}

.btn-outline-success {
  border: 2px solid #0066ff !important;
  background: #fff !important;
  color: #0066ff !important;
}
</style>